import React, { forwardRef } from 'lib/react';
import PropTypes from 'prop-types';
import { EVButton, EVCircularProgress, makeStyles } from '@eagleview/ev-comp-library';
import clsx from 'clsx';

const useStyles = makeStyles((theme) => ({
  defaultButtonClass: ({ variant }) => ({
    textTransform: 'none',
    boxShadow: 'none',
    '&:hover': {
      boxShadow: 'none',
    },
    ...(variant === 'outlined' && {
      backgroundColor: theme.evPalette.salt[100],
    }),
  }),
}));

const Button = forwardRef((props, ref) => {
  const {
    className, loading, LoaderComponent, children, ...rest
  } = props;
  const classes = useStyles({ variant: rest.variant });
  return (
    <EVButton
      className={clsx(classes.defaultButtonClass, className)}
      disabled={loading || rest.disabled}
      ref={ref}
      {...rest}
    >
      {loading ? LoaderComponent : children}
    </EVButton>
  );
});

Button.defaultProps = {
  className: '',
  loading: false,
  LoaderComponent: <EVCircularProgress style={{ width: '24px', height: '24px', color: 'inherit' }} />,
};

Button.propTypes = {
  className: PropTypes.string,
  loading: PropTypes.bool,
  LoaderComponent: PropTypes.node,
};
export default Button;
